import { render } from "./AppSubHeaderIndex.vue?vue&type=template&id=36a81ddf&scoped=true"
import script from "./AppSubHeaderIndex.vue?vue&type=script&lang=js"
export * from "./AppSubHeaderIndex.vue?vue&type=script&lang=js"

import "./AppSubHeaderIndex.vue?vue&type=style&index=0&id=36a81ddf&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36a81ddf"]])

export default __exports__